import React  from 'react'
import DropDown from '../dropdown';
import {Document} from '../../../api/services/next'

const DocumentSubTypeDropDown = ({...rest}) => {			
    return <DropDown search  api={Document.GetDocumentSubType} textField="Name" valueField="Id"  {...rest}/>
}

export default DocumentSubTypeDropDown